export default "__VITE_ASSET__CzRZ1Kmw__"